<div id="review-page">
    <h3 class="subheader col-12 p-0">
        Double-check these details to make sure they match what’s on your ID.
    </h3>
    <div class="col-12 p-0" *ngIf="reviewDetails">
        <div class="content-container">

            <!-- personal details -->
            <div class="d-flex flex-column">
                <div class="d-flex flex-row justify-content-between top-row">
                    <div class="header">Personal details</div>
                    <div class="navigate" (click)="navigatePersonalDetails()">Edit</div>
                </div>

                <div class="personal-details d-flex flex-column">

                    <div class="d-flex flex-row flex-wrap">
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    First name
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.personalDetails.firstName}}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Last name
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.personalDetails.lastName}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-row flex-wrap">
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Date of birth
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.personalDetails.dob | date : 'dd-MM-yyyy'}}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Gender
                                </div>
                                <div class="pd-text">
                                    {{genderText}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-row flex-wrap">
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Email address
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.initialDetails.email}}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Mobile
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.personalDetails.mobile}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-row flex-wrap">
                        <div class="col-12 p-0">
                            <div class="d-flex flex-column">
                                <div class="pd-header">
                                    Residential address
                                </div>
                                <div class="pd-text">
                                    {{reviewDetails.personalDetails.address.fullAddress}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- investment option -->
            <div class="d-flex flex-column">
                <div class="d-flex flex-row justify-content-between top-row">
                    <div class="header">Investment option</div>
                    <div class="navigate" (click)="navigateInvestmentOptions()">Edit</div>
                </div>
            </div>
            <div class="investment-options d-flex flex-column">
                <ng-container *ngFor="let option of reviewDetails.investmentOptions">
                    <app-investment-review-card [investment]="option"></app-investment-review-card>
                </ng-container>
            </div>

            <!-- rollovers -->
            <div class="d-flex flex-column" *ngIf="reviewDetails.rollins.length > 0">
                <div class="d-flex flex-row justify-content-between top-row">
                    <div class="header">Super that you're moving to Verve</div>
                    <div class="navigate" (click)="navigateRollin()">Edit</div>
                </div>
            </div>
            <div class="investment-options d-flex flex-column">
                <ng-container *ngFor="let rollin of reviewDetails.rollins">
                    <app-rollin-review-card [rollin]="rollin"></app-rollin-review-card>
                </ng-container>
            </div>

        </div>
    </div>
    <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 col-12 p-0">
        <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
        </app-button>
        <app-button class="custom" title="Confirm" [isDisabled]="(isLoading$ | async)" icon="east" loading
            (onClick)="onCompleteClick()">
        </app-button>
    </div>
    <div class="footer footer-mobile col-12 mt-5">
        <ng-template class="" [ngTemplateOutlet]="FooterStep7"></ng-template>
    </div>
</div>

<ng-template #FooterStep7>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>